import { createAction, props } from '@ngrx/store';

export const loadFeatureFlags = createAction('[FeatureFlags] Load Feature Flags');
export const loadFeatureFlagsSuccess = createAction(
  '[FeatureFlags] Load Feature Flags Success',
  props<{ featureFlags: any }>()
);
export const loadFeatureFlagsFailure = createAction(
  '[FeatureFlags] Load Feature Flags Failure',
  props<{ error: any }>()
);
